import { render, staticRenderFns } from "./obor.vue?vue&type=template&id=34f6d84e&scoped=true&"
import script from "./obor.vue?vue&type=script&lang=js&"
export * from "./obor.vue?vue&type=script&lang=js&"
import style0 from "./obor.vue?vue&type=style&index=0&id=34f6d84e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f6d84e",
  null
  
)

export default component.exports